import React from 'react';
import config from 'config';

import history from '../../history';
import Table from 'components/table';
import {TdCenter} from 'components/table/components';
import {LinkSmall} from 'components/buttons';

const MailsList = ({mails}) => {

  const handleLinkClick = e => e.stopPropagation()

  return <Table black="black">
    <thead>
    <tr>
      <th>Номер документа</th>
      <th>Назва документа</th>
      <th>Термін виконання</th>
      <th style={{textAlign: "center"}}>Відповідь</th>
    </tr>
    </thead>
    <tbody>
    {
      mails.map((item, i) => (<tr key={i} onClick={(event) => {
        history.push(`/operator/mailing/detail/${item.get('mailing_data').get('id')}`)
      }}>
        <td>
          <span>Номер документа:</span>{
          item.get('mailing_data').get('document_list').size > 0
            ? item.get('mailing_data').get('document_list').get(0).get('document_data').get('number')
            : item.get('mailing_data').get('id')
        }</td>

        {(item.get('status') && new Date(item.get('status')) || Date.now()) >= new Date(item.get('mailing_data').get('time_deadline'))
          ? (<td style={{
            color: "#dd4b39"
          }}>
            <span>Назва документа:</span>
            {
              item.get('mailing_data').get('document_list').size > 0
                ? item.get('mailing_data').get('document_list').get(0).get('document_data').get('name')
                : "Назва розсилки"
            }
          </td>)
          : (<td>
            <span>Назва документа:</span>
            {
              item.get('mailing_data').get('document_list').size > 0
                ? item.get('mailing_data').get('document_list').get(0).get('document_data').get('name')
                : "Назва розсилки"
            }
          </td>)
        }
        <td>
          <span>Термін виконання:</span>{new Date(item.get('mailing_data').get('time_deadline')).toLocaleString('uk-UA', config.options)}
        </td>
        <TdCenter><span>Відповідь:</span>{item.get('status') ? (
          <i style={{color: "#feac01", fontSize: "24px"}} className="fa fa-check-circle" aria-hidden="true"></i>
        ) : (
          <i style={{color: "#d73925", fontSize: "24px"}} className="fa fa-times-circle-o" aria-hidden="true"></i>
        )}
        </TdCenter>
        <td>
          <LinkSmall to={`/operator/mailing/detail/${item.get('mailing_data').get('id')}`}
                     onClick={handleLinkClick}>Детальніше</LinkSmall>
        </td>
      </tr>))
    }
    </tbody>
  </Table>
}

export default MailsList;



// WEBPACK FOOTER //
// ./src/operator/mailing/mails-list.js